import { defineComponent as _defineComponent } from 'vue'
import { PropType, watch } from "vue";
import { useRoute } from "vue-router";


const __default__ = {
  name: "PageModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  shouldShow: {
    type: Boolean,
    default: false,
  },
  onBackHandler: {
    type: Function as PropType<() => void>,
    required: true,
  },
  useVShow: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const route = useRoute();

watch(
  () => props.shouldShow,
  (show) => {
    if (show) {
      route.meta.onBackHandlerList.push(props.onBackHandler);
    } else {
      route.meta.onBackHandlerList.pop();
    }
  }
);

const __returned__ = { props, route }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})